<section id="container">
  <app-menu></app-menu>
  <section id="main-content" class="content">
    <div>This text is always in english</div>
    <div i18n="Dynamic translation test@@translationTest">This text should be in your language.</div>
    <hr />
    <button class="btn btn-primary" (click)="onActionClick()">Action Test Button</button>
    <div class="plan-details">{{ actionResults }}</div>
  </section>
</section>
